// Compatibility translations for older screens that still render Romanian source copy.
// New and actively edited screens should use keys from catalogs.js directly.
export const legacyEnglishCatalog = Object.freeze({
  'Închide': 'Close',
  'Șterge': 'Delete',
  'Sterge': 'Delete',
  'Anulează': 'Cancel',
  'Anuleaza': 'Cancel',
  'Renunță': 'Cancel',
  'Salvează': 'Save',
  'Salvează modificările': 'Save changes',
  'Salvează Modificările': 'Save Changes',
  'Se salvează...': 'Saving...',
  'Se salvează…': 'Saving…',
  'Editează': 'Edit',
  'Editeaza': 'Edit',
  'Actualizează': 'Update',
  'Reîncarcă': 'Reload',
  'Reîncarcă pagina': 'Reload page',
  'Reîncarcă datele': 'Reload data',
  'Reîncearcă': 'Try again',
  'Încearcă din nou': 'Try again',
  'Înapoi': 'Back',
  'Înapoi la Dashboard': 'Back to Dashboard',
  'Înapoi la dashboard': 'Back to dashboard',
  'Înapoi la listă': 'Back to list',
  'Înapoi la login': 'Back to login',
  'Înapoi la șoferi': 'Back to drivers',
  'Înainte': 'Next',
  'Următor': 'Next',
  'Continuă →': 'Continue →',
  'Adaugă': 'Add',
  'Adaugă Document': 'Add Document',
  'Adaugă document': 'Add document',
  'Încarcă': 'Upload',
  'Încarcă Document': 'Upload Document',
  'Încarcă document': 'Upload document',
  'Încarcă documentul': 'Upload the document',
  'Descarcă': 'Download',
  'Descarcă PDF': 'Download PDF',
  'Vizualizează': 'View',
  'Afișează': 'Show',
  'Elimină': 'Remove',
  'Schimbă': 'Change',
  'Caută': 'Search',
  'Caută după nume...': 'Search by name...',
  'Șterge căutarea': 'Clear search',
  'Șterge filtrul': 'Clear filter',
  'Resetează filtrele': 'Reset filters',
  'Selectează': 'Select',
  'Selectați...': 'Select...',
  'Selectează data': 'Select date',
  'Selectează tipul': 'Select type',
  'Selectează categoria': 'Select category',
  'Selectează categoria documentului': 'Select document category',
  'Selectează data expirării': 'Select expiry date',
  'Selectează șofer': 'Select driver',
  'Selectează șoferul': 'Select the driver',
  'Selectează un șofer.': 'Select a driver.',
  'Selectează marca': 'Select make',
  'Selectează Marca': 'Select Make',
  'Selectează combustibilul': 'Select fuel type',
  'Selectează codul': 'Select code',
  'Selectează țara de plecare': 'Select departure country',
  'Selectează țara de destinație': 'Select destination country',
  'Se încarcă...': 'Loading...',
  'Se încarcă datele...': 'Loading data...',
  'Se încarcă documentele...': 'Loading documents...',
  'Se încarcă șoferii...': 'Loading drivers...',
  'Se încarcă semnăturile...': 'Loading signatures...',
  'Se încarcă expedițiile...': 'Loading shipments...',
  'Se încarcă activitatea zilnică...': 'Loading daily activity...',
  'Se procesează...': 'Processing...',
  'Se generează...': 'Generating...',
  'Se verifică...': 'Checking...',
  'Se actualizează...': 'Updating...',
  'Se șterge...': 'Deleting...',
  'Te rog așteaptă...': 'Please wait...',
  'Vă rugăm așteptați': 'Please wait',
  'Eroare': 'Error',
  'Eroare:': 'Error:',
  'Eroare de conexiune. Vă rugăm încercați din nou.': 'Connection error. Please try again.',
  'Nu am putut încărca lista': 'The list could not be loaded',
  'Nu am putut încărca': 'Could not load',
  'Nu s-au găsit rezultate': 'No results found',
  'Nu există rezultate': 'No results',
  'Niciun șofer găsit.': 'No drivers found.',
  'Niciun șofer găsit': 'No drivers found',
  'Nu există șoferi disponibili': 'No drivers available',
  'Nu există camioane disponibile': 'No trucks available',
  'Nu există remorci disponibile': 'No trailers available',
  'Nu există documente': 'No documents',
  'Nu există documente încărcate': 'No documents uploaded',
  'Nu există notificări': 'No notifications',
  'Nu există modificări de salvat.': 'There are no changes to save.',
  'Nu se aplică': 'Not applicable',
  'Acțiuni': 'Actions',
  'Acțiuni rapide': 'Quick actions',
  'Referință transport': 'Transport reference',
  'Fără număr CMR': 'No CMR number',
  'Document neidentificat': 'Unnumbered document',
  'Detalii': 'Details',
  'Informații': 'Information',
  'Informații generale': 'General information',
  'Informații de bază': 'Basic information',
  'Informații Personale': 'Personal Information',
  'Informații personale': 'Personal information',
  'Informații Vehicul': 'Vehicle Information',
  'Observații': 'Notes',
  'Referință': 'Reference',
  'Fișier': 'File',
  'Fișier nou': 'New file',
  'Fișier nou selectat': 'New file selected',
  'Opțional': 'Optional',
  'Data': 'Date',
  'Data:': 'Date:',
  'Data emiterii': 'Issue date',
  'Data expirării': 'Expiry date',
  'Data Expirării': 'Expiry Date',
  'Data Expirării (opțional)': 'Expiry Date (optional)',
  'Data încărcării': 'Upload date',
  'Data transport': 'Transport date',
  'Data transport:': 'Transport date:',
  'Data creării': 'Created on',
  'Fără dată': 'No date',
  'Fără dată selectată': 'No date selected',
  'Fără termen': 'No expiry date',
  'Expiră': 'Expires',
  'Expiră:': 'Expires:',
  'Expiră în:': 'Expires in:',
  'Expiră azi': 'Expires today',
  'Expiră astăzi': 'Expires today',
  'Expiră curând': 'Expiring soon',
  'Expiră în curând': 'Expiring soon',
  'Expiră în 30 zile': 'Expires within 30 days',
  'Finalizat': 'Completed',
  'Finalizată': 'Completed',
  'Finalizat:': 'Completed:',
  'Finalizează': 'Complete',
  'Finalizează acum': 'Complete now',
  'În curs': 'In progress',
  'În progres': 'In progress',
  'În lucru': 'In progress',
  'În așteptare': 'Pending',
  'În Așteptare': 'Pending',
  'În prelucrare': 'Processing',
  'În procesare': 'Processing',
  'În mentenanță': 'In maintenance',
  'În întreținere': 'In maintenance',
  'Întârziat': 'Delayed',
  'Anulată': 'Cancelled',
  'Programată': 'Scheduled',
  'Disponibil': 'Available',
  'Disponibilă': 'Available',
  'Indisponibil': 'Unavailable',
  'Activ': 'Active',
  'Activă': 'Active',
  'Inactiv': 'Inactive',
  'Necunoscut': 'Unknown',
  'Necunoscută': 'Unknown',
  'Neînregistrat': 'Not registered',
  'Neinițiat': 'Not started',
  'Nedefinit': 'Undefined',
  'Toate': 'All',
  'Toți': 'All',
  'Toți șoferii': 'All drivers',
  'Total': 'Total',
  'Total:': 'Total:',
  'Afișare': 'Showing',
  'Pagina': 'Page',
  'Pagina anterioară': 'Previous page',
  'Pagina următoare': 'Next page',
  'Elemente per pagină:': 'Items per page:',
  'Status': 'Status',
  'Status:': 'Status:',
  'Status transport': 'Transport status',
  'Status Transport': 'Transport Status',
  'Toate statusurile': 'All statuses',
  'Status Camion': 'Truck Status',
  'Status taxe': 'Tax status',
  'Tip': 'Type',
  'Tip vehicul': 'Vehicle type',
  'Tip autovehicul': 'Vehicle type',
  'Tip remorcă': 'Trailer type',
  'Tip combustibil': 'Fuel type',
  'Tip motor': 'Engine type',
  'Tip încărcătură': 'Cargo type',
  'Tip activitate': 'Activity type',
  'Locație': 'Location',
  'Durată': 'Duration',
  'Durată:': 'Duration:',
  'Durată calculată': 'Calculated duration',
  'Durată și acțiuni': 'Duration and actions',
  'Început': 'Start',
  'Sfârșit': 'End',
  'Sosire estimată': 'Estimated arrival',
  'Sosire estimată:': 'Estimated arrival:',
  'Încărcare': 'Loading',
  'Încărcare:': 'Loading:',
  'Descărcare': 'Unloading',
  'Ajuns la încărcare': 'Arrived at loading',
  'Încărcare marfă': 'Loading cargo',
  'Încărcare finalizată': 'Loading completed',
  'Ajuns la descărcare': 'Arrived at unloading',
  'Se descarcă': 'Unloading',
  'Descărcare finalizată': 'Unloading completed',
  'Marfă': 'Cargo',
  'Marfă:': 'Cargo:',
  'Natura mărfii': 'Nature of the goods',
  'Mărfuri periculoase': 'Dangerous goods',
  'Greutate brută': 'Gross weight',
  'Greutate netă': 'Net weight',
  'Greutate totală': 'Total weight',
  'Greutate goală': 'Empty weight',
  'Greutate în gol': 'Empty weight',
  'Greutate încărcătură': 'Cargo weight',
  'Greutate maximă': 'Maximum weight',
  'Greutate admisă': 'Permitted weight',
  'Greutate totală admisă': 'Total permitted weight',
  'Greutate totală permisă': 'Total permitted weight',
  'Sarcină utilă': 'Payload',
  'Capacitate de încărcare': 'Load capacity',
  'Volum marfă': 'Cargo volume',
  'Lățime': 'Width',
  'Înălțime': 'Height',
  'Lungime': 'Length',
  'Marcă': 'Make',
  'Marcă:': 'Make:',
  'Model': 'Model',
  'An fabricație': 'Year of manufacture',
  'Număr': 'Number',
  'Număr înmatriculare': 'Registration number',
  'Număr șasiu': 'Chassis number',
  'Serie șasiu': 'Chassis series',
  'Serie șasiu / VIN': 'Chassis series / VIN',
  'VIN / Șasiu': 'VIN / Chassis',
  'Număr axe': 'Number of axles',
  'Număr osii': 'Number of axles',
  'Configurație osii': 'Axle configuration',
  'Tracțiune': 'Drivetrain',
  'Tip tracțiune': 'Drivetrain type',
  'Viteză maximă': 'Maximum speed',
  'Viteză maximă permisă': 'Maximum permitted speed',
  'Țară': 'Country',
  'Țară *': 'Country *',
  'Adresă': 'Address',
  'Adresă Email': 'Email Address',
  'Adresă completă': 'Full address',
  'Telefon': 'Phone',
  'Telefon:': 'Phone:',
  'Telefon contact': 'Contact phone',
  'Număr de Telefon': 'Phone Number',
  'Nume': 'Name',
  'Nume:': 'Name:',
  'Nume + Prenume': 'First and last name',
  'Nume complet *': 'Full name *',
  'Nume expeditor': 'Sender name',
  'Nume șofer': 'Driver name',
  'Email (opțional)': 'Email (optional)',
  'Parolă': 'Password',
  'Schimbă parola': 'Change password',
  'Confirmă parola nouă': 'Confirm new password',
  'Introdu parola nouă': 'Enter the new password',
  'Parolă curentă *': 'Current password *',
  'Introduceți parola curentă': 'Enter your current password',
  'Documente': 'Documents',
  'Documente Personale': 'Personal Documents',
  'Documente personale': 'Personal documents',
  'Documente încărcate': 'Uploaded documents',
  'Documente semnate': 'Signed documents',
  'Documente expirate': 'Expired documents',
  'Documente Expirate': 'Expired Documents',
  'Documente flotă': 'Fleet documents',
  'Documente cu termen apropiat': 'Documents approaching expiry',
  'Total documente': 'Total documents',
  'Nume Document': 'Document Name',
  'Editează document': 'Edit document',
  'Editează Document': 'Edit Document',
  'Editează documentul': 'Edit the document',
  'Șterge document': 'Delete document',
  'Șterge documentul': 'Delete the document',
  'Gestionează documente': 'Manage documents',
  'Camion': 'Truck',
  'Camioane': 'Trucks',
  'Remorcă': 'Trailer',
  'Remorci': 'Trailers',
  'Șofer': 'Driver',
  'Sofer': 'Driver',
  'Șoferi': 'Drivers',
  'Transport': 'Transport',
  'Transporturi': 'Transports',
  'Expediție': 'Shipment',
  'Planificare expediții': 'Shipment planning',
  'Intervenții': 'Service jobs',
  'Notificări': 'Notifications',
  'Utilizatori': 'Users',
  'Profil': 'Profile',
  'Casă de expediție': 'Freight forwarding',
  'Flotă proprie': 'Own fleet',
  'Transportatori subcontractați': 'Subcontracted carriers',
  'Cotații transport': 'Transport quotations',
  'Șofer / Client': 'Driver / Customer',
  'Camion / Transportator': 'Truck / Carrier',
  'Remorcă / Vândut': 'Trailer / Sold',
  'Comandă:': 'Order:',
  'Nr. transport:': 'Transport no.:',
  'În desfășurare la transportator': 'In progress with carrier',
  'Vândut': 'Sold',
  'Confirmare Ștergere Transport': 'Confirm Transport Deletion',
  'Confirmare Ștergere Șofer': 'Confirm Driver Deletion',
  'Confirmare Ștergere Camion': 'Confirm Truck Deletion',
  'Confirmare Ștergere Remorcă': 'Confirm Trailer Deletion',
  'Gestionează transporturile active': 'Manage active transports',
  'Gestionează șoferii companiei': 'Manage company drivers',
  'Total Transporturi': 'Total Transports',
  'Total Șoferi': 'Total Drivers',
  'Status Finalizare': 'Completion Status',
  'Caută după nr. transport, comandă client, camion, remorcă, expeditor, destinatar...': 'Search by transport no., customer order, truck, trailer, sender, recipient...',
  'Puteți vizualiza toate transporturile din sistem sau doar transporturile pe care le puteți edita (cele create de dumneavoastră ca dispecer).': 'You can view all transports in the system or only those you can edit (the ones you created as dispatcher).',
  'Locația nu a fost specificată încă': 'The location has not been specified yet',
  'Nu există camioane': 'No trucks',
  'Nu există camioane înregistrate în sistem.': 'There are no trucks registered in the system.',
  'Nu s-au găsit remorci': 'No trailers found',
  'Nu există remorci înregistrate în sistem.': 'There are no trailers registered in the system.',
  'Introduceți adresa de email': 'Enter the email address',
  'Email-ul este necesar pentru 2FA și notificări': 'Email is required for 2FA and notifications',
  'Țară transportator': 'Carrier country',
  'Adresă transportator': 'Carrier address',
  'Setări autentificare 2FA': '2FA authentication settings',
  'Notificări WhatsApp': 'WhatsApp notifications',
  'Primește alerte pentru documente care expiră': 'Receive alerts for expiring documents',
  'Verificați inbox-ul și urmați link-ul pentru a vă reseta parola.': 'Check your inbox and follow the link to reset your password.',
  'Încarcă primul tău document personal': 'Upload your first personal document',
  'Modifică detaliile documentului': 'Update document details',
  'Modifică Document': 'Update Document',
  'Actualizează parola contului': 'Update your account password',
  'Cerințe minime': 'Minimum requirements',
  'Cel puțin o literă și o cifră': 'At least one letter and one number',
  'Diferită de parola actuală': 'Different from the current password',
  'Adaugă un document personal nou': 'Add a new personal document',
  'Se folosește la intervalele trimise către AROBS și gestionează automat ora de vară.': 'Used for intervals sent to AROBS and automatically handles daylight saving time.',
  'Acces Restricționat': 'Restricted Access',
  'Acces restricționat': 'Restricted access',
  'Marchează ca citit': 'Mark as read',
  'Marchează toate ca citite': 'Mark all as read',
  'Deschide notificările': 'Open notifications',
  'Alte activități': 'Other activities',
  'Pauză / odihnă': 'Break / rest',
  'Odihnă': 'Rest',
  'Activitate zilnică șofer': 'Daily driver activity',
  'Expediții luna curentă': 'Shipments this month',
  'Luna curentă': 'Current month',
  'Luna trecută': 'Last month',
  'Săptămâna curentă': 'Current week',
  'Săptămâna trecută': 'Last week',
  'Perioadă': 'Period',
  'Perioadă selectată': 'Selected period',
  'Monedă': 'Currency',
  'Preț': 'Price',
  'Pret': 'Price',
  'Cost': 'Cost',
  'Cost Total': 'Total Cost',
  'Cost total': 'Total cost',
  'Diurnă': 'Per diem',
  'Rată lunară': 'Monthly payment',
  'Amortizare lunară': 'Monthly depreciation',
  'Asigurare marfă': 'Cargo insurance',
  'Rovinietă': 'Road vignette',
  'Motorină': 'Diesel',
  'Benzină': 'Petrol',
  'ID încărcare:': 'Upload ID:',
  'Documente (': 'Documents (',
  'activități înregistrate': 'activities recorded',
  'Închide editarea': 'Close editing',
  'Editare expediție': 'Edit shipment',
  'Cumpărător:': 'Buyer:',
  'Remorcă:': 'Trailer:',
  'Vamă #': 'Customs #',
  'Vezi detalii semnătură': 'View signature details',
  'expediții luna curentă': 'shipments this month',
  'Se analizează documentul cu AI...': 'Analyzing the document with AI...',
  'Se detectează': 'Detecting',
  'Capacități Transport': 'Transport Capabilities',
  'Activ (implicit admin)': 'Active (admin default)',
  'Nu există expediții active sau programate pentru selecția curentă.': 'There are no active or scheduled shipments for the current selection.',
  'Nu există date zilnice în perioada selectată.': 'There is no daily data for the selected period.',
  'Zi selectată': 'Selected day',
  'Șofer selectat:': 'Selected driver:',
  'Perioadă rapidă': 'Quick period',
  'Data început': 'Start date',
  'Data sfârșit': 'End date',
  'Total activitate': 'Total activity',
  'Perioada selectată • doar activitatea DRIVING': 'Selected period • DRIVING activity only',
  'Șoferi cu ore de condus:': 'Drivers with driving hours:',
  'Evoluție relativă ore conduse (': 'Relative change in driving hours (',
  'Grafic comparativ ore condus pe șofer': 'Driving-hours comparison by driver',
  'Axa X: poziția în clasament • Axa Y: ore condus în perioada selectată': 'X-axis: ranking position • Y-axis: driving hours in the selected period',
  'Nu s-au putut încărca datele pentru niciunul dintre șoferi': 'Data could not be loaded for any driver',
  'Încearcă să reîncarci pagina sau verifică conexiunea la internet': 'Try reloading the page or check your internet connection',
  'Nu există date de condus pentru perioada selectată': 'There is no driving data for the selected period',
  'Selectează o altă perioadă sau verifică dacă sunt șoferi disponibili': 'Select another period or check whether drivers are available',
  'Se încarcă restul șoferilor...': 'Loading the remaining drivers...',
  'Caută țară sau cod...': 'Search by country or code...',
  'Adaugă CMR': 'Add CMR',
  'Șofer:': 'Driver:',
  'Număr remorcă externă': 'External trailer number',
  'Adaugă vamă': 'Add customs stop',
  'Nu sunt adăugate treceri de frontieră.': 'No border crossings have been added.',
  'Informații CMR': 'CMR Information',
  'Am înțeles': 'Got it',
  'Închid': 'Close',
  'Micșorează timeline': 'Zoom out timeline',
  'Zoom timeline activități': 'Activity timeline zoom',
  'Mărește timeline': 'Zoom in timeline',
  'Oră început': 'Start time',
  'Oră sfârșit': 'End time',
  'Ora plecării': 'Departure time',
  'Schimbă perioada': 'Change period',
  'Se încarcă datele tahografului...': 'Loading tachograph data...',
  'Activități zilnice': 'Daily activities',
  'Nu există date pentru perioada selectată': 'There is no data for the selected period',
  'Observații șoferi': 'Driver notes',
  'Descriere (opțional)': 'Description (optional)',
  'Nu există intervenții înregistrate': 'No service jobs recorded',
  'Editare camion': 'Edit truck',
  'Nu s-au putut încărca documentele': 'Documents could not be loaded',
  'Anuleaza editarea': 'Cancel editing',
  'Tip intervenție': 'Service job type',
  'Selectează fișier *': 'Select file *',
  'Toate Tipurile': 'All Types',
  'Înapoi la intervenții': 'Back to service jobs',
  'Înapoi la profitabilitate': 'Back to profitability',
  'Număr document': 'Document number',
  'Total cereri': 'Total requests',
  'Distanță': 'Distance',
  'Distanță Totală': 'Total Distance',
  'Semnături Electronice': 'Electronic Signatures',
  'CMR-ul a fost trimis pentru semnătură electronică': 'The CMR was sent for electronic signature',
  'Rută calculată': 'Calculated route',
  'Kilometri folosiți în calcul': 'Kilometres used in the calculation',
  'Deschide în tab nou': 'Open in a new tab',
  'Creează expediție': 'Create shipment',
  'Prea multe cereri. Acțiunile sunt blocate încă': 'Too many requests. Actions remain blocked',
  'Se încarcă avizele...': 'Loading delivery notes...',
  'Nu există avize pentru acest transport': 'There are no delivery notes for this transport',
  'Creează Primul Aviz': 'Create the First Delivery Note',
  'Creează Aviz Nou': 'Create New Delivery Note',
  'Date / Data': 'Date',
  'Date / Data:': 'Date:',
  'Date / Data: _______________': 'Date: _______________',
  'SCRISOARE DE TRĂSURĂ - DOCUMENT DE TRANSPORT': 'CONSIGNMENT NOTE - TRANSPORT DOCUMENT',
  'Dacă locul convenit pentru preluare și cel pentru livrare se află în țări diferite, se aplică Convenția CMR și Condițiile Generale de Transport 2002 (ultima versiune).': 'If the agreed pickup and delivery locations are in different countries, the CMR Convention and the General Transport Conditions 2002 (latest version) apply.',
  'Price / Preț': 'Price',
  'Total / Total': 'Total',
  '| AtruX Transport Management System | Conform Convenției CMR / In accordance with the CMR Convention': '| AtruX Transport Management System | In accordance with the CMR Convention',
  'Număr CMR': 'CMR number',
  'Completează CMR': 'Complete CMR',
  'Nu există încă documente semnate pentru acest transport.': 'There are no signed documents for this transport yet.',
  '← Înapoi': '← Back',
  '✓ Categoria selectată:': '✓ Selected category:',
  'Lună': 'Month',
  'Sumă/zi': 'Amount/day',
  'Total EUR': 'Total EUR',
  'transporturi în coadă': 'transports in queue',
  'Rută:': 'Route:',
  'Șterge toate': 'Delete all',
  '✓ Documentul a fost adăugat!': '✓ The document was added!',
  'Introduceți numele documentului': 'Enter the document name',
  'Nume categorie personalizată *': 'Custom category name *',
  'Introduceți numele categoriei': 'Enter the category name',
  'Introduceți descrierea documentului': 'Enter the document description',
  'Sfârșit valabilitate': 'Valid until',
  'modificări nesalvate': 'unsaved changes',
  'Modificări detectate': 'Changes detected',
  'Se salvează doar câmpurile modificate.': 'Only changed fields are saved.',
  'Selectează scop operațiune': 'Select operation purpose',
  'Selectează județ': 'Select county',
  'Stradă (opțional)': 'Street (optional)',
  'Fără șofer': 'No driver',
  'Fără remorcă': 'No trailer',
  'Din țara': 'From country',
  'Către țara': 'To country',
  'Închisă automat la finalizare': 'Closed automatically upon completion',
  'Mută sus': 'Move up',
  'Mută jos': 'Move down',
  'Analiză Documente cu AI': 'AI Document Analysis',
  'Selectează Tipul de Analiză': 'Select Analysis Type',
  '• Folosește imagini clare și bine iluminate': '• Use clear, well-lit images',
  '• Evită reflexiile și umbrele pe documente': '• Avoid glare and shadows on documents',
  '• Pentru OCR, alege nivel de detaliu "Înalt"': '• For OCR, choose the High detail level',
  '• Fii specific în instrucțiuni pentru rezultate precise': '• Be specific in your instructions for accurate results',
  'Informații despre costuri și limite': 'Cost and limit information',
  'Întreabă orice despre transporturi, șoferi și documente': 'Ask anything about transports, drivers, and documents',
  'Adaugare sofer nou': 'Add new driver',
  'Introduceți numele': 'Enter the name',
  'Informații Cont': 'Account Information',
  'Parolă generată automat': 'Automatically generated password',
  'Parolă puternică generată automat': 'Strong automatically generated password',
  'Adaugare remorca': 'Add trailer',
  'Adaugare camion': 'Add truck',
  'Specificații tehnice': 'Technical specifications',
  'Specificații greutate': 'Weight specifications',
  'Informații axe': 'Axle information',
  'Informații motor': 'Engine information',
  'Informații încărcare și viteză': 'Load and speed information',
  'Mediu & Siguranță': 'Environment & Safety',
  'Selectează clasa': 'Select class',
  'Selectează Tipul': 'Select Type',
  'Selectează Categoria Tunel': 'Select Tunnel Category',
  'Selectează Clasa Mărfuri Periculoase': 'Select Dangerous Goods Class',
  'Include simultan rata și amortizarea': 'Include both the payment and depreciation',
  'Selectează Tipul Motorului': 'Select Engine Type',
  'Selectează Tipul Combustibilului': 'Select Fuel Type',
  'Selectează Standardul de Emisii': 'Select Emission Standard',
  'Selectează Codul de Restricție Tunel': 'Select Tunnel Restriction Code',
  'Istoric Activități Sistem': 'System Activity History',
  'Monitorizează toate acțiunile utilizatorilor din platformă': 'Monitor all user actions in the platform',
  'Caută după nume utilizator, acțiune sau detalii activitate...': 'Search by user name, action, or activity details...',
  'Eroare la încărcarea jurnalelor de activitate': 'Error loading activity logs',
  'Nu s-au găsit activități': 'No activities found',
  'Resetează categoria': 'Reset category',
  'Reîncarcă activitățile': 'Reload activities',
  'Total activități': 'Total activities',
  'Pagina curentă': 'Current page',
  'În': 'In',
  'fișier(e)': 'file(s)',
  'Limită: 20 cereri pe oră per utilizator. Costurile variază în funcție de nivelul de detaliu:': 'Limit: 20 requests per hour per user. Costs vary by detail level:',
  '• Nivel înalt (OCR): ~$0.004 per imagine': '• High level (OCR): ~$0.004 per image',
  '• Nivel scăzut (rapid): ~$0.0003 per imagine': '• Low level (fast): ~$0.0003 per image',
  '• Automat: cost variabil bazat pe conținut': '• Automatic: variable cost based on content',
  'Administrează toate conturile din sistem': 'Manage all accounts in the system',
  'Nou utilizator': 'New user',
  'Caută utilizatori...': 'Search users...',
  'Toți (': 'All (',
  'Nu s-au găsit utilizatori': 'No users found',
  'Resetează parolă': 'Reset password',
  'Confirmă ștergerea': 'Confirm deletion',
  'Ești sigur că vrei să ștergi acest utilizator? Această acțiune nu poate fi anulată.': 'Are you sure you want to delete this user? This action cannot be undone.',
  'Funcționalitatea de creare utilizatori va fi implementată în curând.': 'User creation will be available soon.',
  'Dacă există un cont cu această adresă, instrucțiunile de resetare au fost trimise la': 'If an account exists with this address, reset instructions were sent to',
  'Înapoi la autentificare': 'Back to sign in',
  'Ați uitat parola?': 'Forgot your password?',
  'Introduceți adresa de email și vă vom trimite instrucțiuni pentru resetare': 'Enter your email address and we will send you reset instructions',
  'introduceți email-ul': 'enter your email',
  'Veți primi un email': 'You will receive an email',
  'Link-ul de resetare va fi valid pentru 24 de ore. Verificați și folderul Spam dacă nu găsiți emailul.': 'The reset link will be valid for 24 hours. Check your Spam folder if you cannot find the email.',
  'Vă amintiți parola?': 'Remember your password?',
  'Autentificați-vă': 'Sign in',
  'Parolă resetată cu succes!': 'Password reset successfully!',
  'Parola dvs. a fost schimbată cu succes.': 'Your password was changed successfully.',
  'Din motive de securitate, va trebui să vă autentificați din nou cu noua parolă.': 'For security reasons, you will need to sign in again with the new password.',
  'Resetare parolă': 'Reset password',
  'Introduceți noua parolă pentru contul dvs.': 'Enter the new password for your account.',
  'Parolă nouă': 'New password',
  'Confirmați parola': 'Confirm password',
  'Confirmați parola nouă': 'Confirm the new password',
  'Cerințe parolă': 'Password requirements',
  'O literă mare': 'One uppercase letter',
  'O literă mică': 'One lowercase letter',
  'O cifră': 'One number',
  'Se resetează...': 'Resetting...',
  'Solicitați un nou link': 'Request a new link',
  'Click pentru detalii semnături': 'Click for signature details',
  'în așteptare': 'pending',
  'Caută după expeditor, destinatar, localitate încărcare/livrare...': 'Search by sender, recipient, loading/delivery location...',
  'Caută după expeditor...': 'Search by sender...',
  'Selectează data de început': 'Select start date',
  'Selectează data de sfârșit': 'Select end date',
  'Resetează filtre': 'Reset filters',
  'Aplică filtre': 'Apply filters',
  'Se încarcă CMR-urile...': 'Loading CMR documents...',
  'Status Semnătură': 'Signature Status',
  'Nicio semnătură': 'No signatures',
  'Încarcă CMR fizic': 'Upload physical CMR',
  'expediții': 'shipments',
  'Timp condus rămas (': 'Remaining driving time (',
  'Ore rămase (': 'Hours remaining (',
  'Micșorează': 'Zoom out',
  'Mărește': 'Zoom in',
  'Date de bază CMR': 'Basic CMR Details',
  'Completează datele obligatorii pentru a crea un CMR nou.': 'Complete the required details to create a new CMR.',
  'Nume expeditor *': 'Sender name *',
  'Nume destinatar *': 'Recipient name *',
  'Loc încărcare *': 'Loading location *',
  'Creează CMR': 'Create CMR',
  'Scrie numele vămii': 'Enter the customs point name',
  'Adauga componenta': 'Add component',
  'REÎNCEARCĂ': 'TRY AGAIN',
  'Selecția stabilește cum se calculează venitul: preț unic sau componente de grupaj.': 'The selection determines how revenue is calculated: a single price or groupage components.',
  'Completați formularul pentru a crea un transport nou și a genera automat documentul CMR': 'Complete the form to create a new transport and automatically generate the CMR document',
  'Schimbă tipul': 'Change type',
  'Cine execută transportul?': 'Who performs the transport?',
  'Alege flota proprie sau intermedierea prin casa de expediție.': 'Choose your own fleet or freight-forwarding brokerage.',
  'Alegeți fluxul: transport simplu sau transport creat pe baza unui aviz standard.': 'Choose the workflow: standard transport or transport created from a delivery note.',
  'Completezi manual transportul și avizul după creare.': 'Complete the transport and delivery note manually after creation.',
  'Încarci aviz PDF, Word sau poză; extragem automat datele din PDF/imagini.': 'Upload a PDF, Word document, or photo; data is extracted automatically from PDFs and images.',
  'Adaugă alt aviz': 'Add another delivery note',
  'Elimină avize': 'Remove delivery notes',
  'Se detectează datele și opririle din documente...': 'Detecting data and stops from documents...',
  'Se creează automat câte un CMR pentru fiecare aviz încărcat. Folosește + dacă ai nevoie de CMR-uri suplimentare.': 'One CMR is created automatically for each uploaded delivery note. Use + if you need additional CMR documents.',
  'Avize încărcate:': 'Uploaded delivery notes:',
  'Verificați câmpurile completate automat și completați restul informațiilor necesare.': 'Review the automatically completed fields and fill in the remaining required information.',
  'Opțional: încarcă un PDF, Word sau o poză. Datele detectate vor completa automat transportul.': 'Optional: upload a PDF, Word document, or photo. Detected data will automatically complete the transport.',
  'Elimină documentul': 'Remove document',
  'Citim documentul și completăm datele detectate...': 'Reading the document and filling in detected data...',
  'Descărcare:': 'Unloading:',
  'Șofer extern:': 'External driver:',
  'Verifică informațiile completate automat înainte de crearea transportului.': 'Review the automatically completed information before creating the transport.',
  'Informații transport': 'Transport information',
  'ȘOFER': 'DRIVER',
  'Caută șofer după nume...': 'Search driver by name...',
  'Caută număr, marcă sau model...': 'Search by number, make, or model...',
  'REMORCĂ': 'TRAILER',
  'Caută număr, marcă, model sau tip...': 'Search by number, make, model, or type...',
  'NUMĂR ÎNMATRICULARE CAMION': 'TRUCK REGISTRATION NUMBER',
  'MARCĂ / MODEL': 'MAKE / MODEL',
  'NUMĂR ÎNMATRICULARE REMORCĂ': 'TRAILER REGISTRATION NUMBER',
  'TIP MĂRFURI': 'GOODS TYPE',
  'Introduceți tipul de marfă transportată': 'Enter the type of goods being transported',
  'PREȚ': 'PRICE',
  'NUMĂR COMANDĂ': 'ORDER NUMBER',
  'VĂMI / TRECERI FRONTIERĂ ·': 'CUSTOMS / BORDER CROSSINGS ·',
  'NUME VAMĂ': 'CUSTOMS POINT NAME',
  'OBSERVAȚII': 'NOTES',
  'DIN ȚARA': 'FROM COUNTRY',
  'CĂTRE ȚARA': 'TO COUNTRY',
  'Date casă de expediție': 'Freight-forwarding details',
  'Selectează clientul, transportatorul subcontractat și valorile comerciale.': 'Select the customer, subcontracted carrier, and commercial values.',
  'Se încarcă partenerii disponibili...': 'Loading available partners...',
  'Selectează clientul': 'Select customer',
  'Actualizează raportul': 'Refresh report',
  'Acțiuni pentru completarea raportului': 'Actions for completing the report',
  'Completează costurile sursă înainte de recalculare.': 'Complete the source costs before recalculating.',
  'Se încarcă datele complete ale grupului…': 'Loading complete group data…',
  'Grupul este respins și exclus din profitabilitate. Poți actualiza doar notele.': 'The group is rejected and excluded from profitability. You can update notes only.',
  'Aceste valori se aplică întregului grup.': 'These values apply to the entire group.',
  'Lasă gol pentru traseul calculat automat.': 'Leave blank for the automatically calculated route.',
  'Observații despre grup': 'Group notes',
  'Editează doar datele care intră în calculul profitabilității.': 'Edit only the data used in the profitability calculation.',
  'Importă documente de combustibil': 'Import fuel documents',
  'Încarcă facturile de combustibil, apoi verifică numărul camionului, perioada, suma și moneda înainte de import.': 'Upload fuel invoices, then check the truck number, period, amount, and currency before importing.',
  'Fișiere analizate:': 'Analyzed files:',
  'Aplică în profitabilitate': 'Apply to profitability',
  'documente pregătite pentru verificare': 'documents ready for review',
  'Verificare necesară': 'Review required',
  'Verificare alimentări': 'Review fuel entries',
  'Valorile eligibile vor apărea în tabel ca „distribuite după zile active”': 'Eligible values will appear in the table as “distributed by active days”',
  'Data facturii': 'Invoice date',
  'Început perioadă': 'Period start',
  'Sfârșit perioadă': 'Period end',
  'Camion negăsit': 'Truck not found',
  'Data alimentării': 'Fuel date',
  'Completează data alimentării sau perioada documentului.': 'Complete the fuel date or document period.',
  'Scroll stânga': 'Scroll left',
  '← Stânga': '← Left',
  'Nu există grupuri pentru luna selectată.': 'There are no groups for the selected month.',
  'Cursă': 'Trip',
  'Costuri cursă': 'Trip costs',
  'Cost fix camion alocat': 'Allocated fixed truck cost',
  'Total cheltuieli cursă': 'Total trip expenses',
  'Profit final cursă': 'Final trip profit',
  'Sursă:': 'Source:',
  'Diurnă alocată grupului': 'Per diem allocated to the group',
  'Include diurnă': 'Include per diem',
  '+ camion': '+ truck',
  'Venituri − total cheltuieli': 'Revenue − total expenses',
  'valoare corectată': 'corrected value',
  'Editează total lună': 'Edit monthly total',
  'Editează totalurile lunii': 'Edit monthly totals',
  '· corecțiile se salvează separat și nu modifică transporturile.': '· corrections are saved separately and do not change transports.',
  'Câmp': 'Field',
  'Final afișat': 'Displayed final value',
  'Valoare corectată': 'Corrected value',
  'Folosește valoarea calculată': 'Use calculated value',
  'Motivul corecției manuale': 'Reason for manual correction',
  'Lasă un câmp gol pentru valoarea calculată automat. Dacă modifici cheltuielile fără să setezi totalul sau profitul, acestea se recalculează automat.': 'Leave a field blank to use the automatically calculated value. If you change expenses without setting the total or profit, they are recalculated automatically.',
  'Nu există transporturi în acest rând.': 'There are no transports in this row.',
  '. Se recalculează din facturile camionului.': '. Recalculated from truck invoices.',
  'Diurnă (EUR)': 'Per diem (EUR)',
  'Total cheltuieli': 'Total expenses',
  '· costuri preluate direct din vehicule și șoferii activi': '· costs taken directly from vehicles and active drivers',
  'Închide costurile fixe': 'Close fixed costs',
  'Calculată automat o singură dată pentru fiecare vehicul eligibil și fiecare șofer activ.': 'Calculated automatically once for each eligible vehicle and each active driver.',
  'Total fix raport': 'Report fixed-cost total',
  'Editează costurile sursă': 'Edit source costs',
  'Asocieri și setări lunare': 'Monthly associations and settings',
  'Folosite pentru note, asocieri și profit split; nu determină vehiculele și nu sunt sursa totalului fix.': 'Used for notes, associations, and profit split; they do not determine vehicles and are not the source of the fixed total.',
  'Editează camioane': 'Edit trucks',
  'Editează remorci': 'Edit trailers',
  'Editează șoferi': 'Edit drivers',
  'Observații lunare': 'Monthly notes',
  'Nu există setări lunare. Costurile fixe automate sunt calculate oricum din toate vehiculele eligibile și șoferii activi.': 'There are no monthly settings. Automatic fixed costs are still calculated from all eligible vehicles and active drivers.',
  'Împărțire profit': 'Profit split',
  'Nu există venituri incluse pentru calcul automat.': 'There is no included revenue for automatic calculation.',
  'Nu există split manual configurat.': 'No manual split is configured.',
  'Preferințe Rută': 'Route Preferences',
  'Configurează opțiunile de calcul al rutei': 'Configure route calculation options',
  'Opțiuni Rutare': 'Routing Options',
  'Rapid (minimizează timpul)': 'Fast (minimize time)',
  'Economic (minimizează costurile)': 'Economical (minimize costs)',
  'Scurt (minimizează distanța)': 'Short (minimize distance)',
  'Trafic în timp real': 'Real-time traffic',
  'Leu românesc (RON)': 'Romanian leu (RON)',
  'Liră sterlină (GBP)': 'Pound sterling (GBP)',
  'Coroană cehă (CZK)': 'Czech koruna (CZK)',
  'Limbă': 'Language',
  'Engleză': 'English',
  'Română': 'Romanian',
  'Germană': 'German',
  'Franceză': 'French',
  'Italiană': 'Italian',
  'Spaniolă': 'Spanish',
  'Viteză Maximă (km/h)': 'Maximum Speed (km/h)',
  'Opțiuni Emisii': 'Emission Options',
  'Opțiuni Costuri Monetare': 'Monetary Cost Options',
  'Cost muncă pe oră (': 'Labour cost per hour (',
  'Ore de Lucru și Pauze Șofer (Legislație RO/EU)': 'Driver Working Hours and Breaks (RO/EU Legislation)',
  'Legislație Europeană (Reg. CE 561/2006):': 'European Legislation (EC Reg. 561/2006):',
  '• Conducere continuă: max 4.5 ore, apoi pauză min 45 min': '• Continuous driving: max 4.5 hours, then a minimum 45-minute break',
  '• Conducere zilnică: max 9 ore (poate fi extinsă la 10 ore, de 2 ori/săptămână)': '• Daily driving: max 9 hours (may be extended to 10 hours twice a week)',
  '• Conducere săptămânală: max 56 ore': '• Weekly driving: max 56 hours',
  '• Conducere bi-săptămânală: max 90 ore': '• Fortnightly driving: max 90 hours',
  '• Repaus zilnic regulat: min 11 ore (poate fi redus la 9 ore, de 3 ori/săptămână)': '• Regular daily rest: min 11 hours (may be reduced to 9 hours three times a week)',
  'Standard EU: 9h sau 10h (extins, 2 ori/săptămână)': 'EU standard: 9h or 10h (extended twice a week)',
  'Include conducere + așteptare + încărcare': 'Includes driving + waiting + loading',
  'Conducere Continuă Max (ore)': 'Maximum Continuous Driving (hours)',
  'Standard EU: 4.5h înainte de pauză obligatorie': 'EU standard: 4.5h before a mandatory break',
  'Pauză Minimă După Conducere (minute)': 'Minimum Break After Driving (minutes)',
  '60 minute (1 oră)': '60 minutes (1 hour)',
  'Standard EU: 45min după 4.5h conducere': 'EU standard: 45min after 4.5h driving',
  'Standard EU: 11h (regulat) sau 9h (redus, 3 ori/săptămână)': 'EU standard: 11h (regular) or 9h (reduced, three times a week)',
  'Completați câmpurile conform legislației europene (Reg. CE 561/2006) și românești pentru calcularea corectă a rutei cu pauzele obligatorii.': 'Complete the fields in accordance with European (EC Reg. 561/2006) and Romanian legislation to calculate the route correctly with mandatory breaks.',
  'Țări Blocate (Interzise)': 'Blocked Countries (Forbidden)',
  'Caută țară... (ex: Austria, AT)': 'Search country... (e.g. Austria, AT)',
  'Țări blocate:': 'Blocked countries:',
  'Nicio țară găsită': 'No country found',
  '💡 Țările selectate vor fi': '💡 Selected countries will be',
  'în calcul. Ruta nu va trece niciodată prin aceste țări.': 'in the calculation. The route will never pass through these countries.',
  'Preț recomandat': 'Recommended price',
  'Fără TVA': 'Excluding VAT',
  'Preț pe kilometru': 'Price per kilometre',
  'Cotație nouă': 'New quotation',
  'Costurile de mai jos folosesc încă distanța anterioară. Recalculează pentru a salva noul preț.': 'The costs below still use the previous distance. Recalculate to save the new price.',
  'Poți modifica distanța. Recalcularea va salva o cotație nouă.': 'You can change the distance. Recalculating will save a new quotation.',
  'Distanță folosită': 'Distance used',
  'Distanță calculată': 'Calculated distance',
  'Durată taxată': 'Charged duration',
  'Distanța a fost modificată manual. Taxele și durata rutei rămân cele calculate inițial.': 'The distance was changed manually. Tolls and route duration remain as originally calculated.',
  'Structura prețului': 'Price structure',
  'Cotațiile pot fi create doar de administratori și dispeceri.': 'Quotations can only be created by administrators and dispatchers.',
  'Se pregătește modulul de cotații...': 'Preparing the quotations module...',
  'Calculează prețul recomandat pe baza rutei și a costurilor companiei.': 'Calculate the recommended price based on the route and company costs.',
  'Completează configurarea': 'Complete configuration',
  'Reîncearcă aceeași cerere': 'Retry the same request',
  'Rută și program': 'Route and schedule',
  'Caută adresa de încărcare': 'Search loading address',
  'Caută adresa de descărcare': 'Search unloading address',
  'Resurse opționale': 'Optional resources',
  'Dacă nu selectezi o resursă, calculul folosește mediile configurate ale companiei.': 'If you do not select a resource, the calculation uses the configured company averages.',
  'Configurație ADR': 'ADR configuration',
  'Ajustări calcul': 'Calculation adjustments',
  'Valoare modificată pentru calculul curent': 'Value changed for the current calculation',
  'Configurează calculul': 'Configure calculation',
  'valori implicite neconfigurate. Alege resurse cu profil complet sau completează mediile companiei.': 'default values are not configured. Choose resources with a complete profile or complete the company averages.',
  'Se calculează...': 'Calculating...',
  'Salvează și calculează': 'Save and calculate',
  'Prețurile sunt în EUR, fără TVA.': 'Prices are in EUR, excluding VAT.',
  'Nu există încă nicio cotație': 'There are no quotations yet',
  'Prima cotație calculată va apărea aici.': 'The first calculated quotation will appear here.',
  'Comandă client:': 'Customer order:',
  'Locație Încărcare': 'Loading Location',
  'Locație Livrare': 'Delivery Location',
  'Status UIT (ANAF)': 'UIT Status (ANAF)',
  'Nu există încă ID de încărcare eTransport pentru acest transport. Generează mai întâi un cod UIT.': 'There is no eTransport upload ID for this transport yet. Generate a UIT code first.',
  'Status curent:': 'Current status:',
  'Nu am putut verifica statusul în acest moment. Încearcă din nou.': 'The status could not be checked right now. Please try again.',
  'Detalii Comandă': 'Order Details',
  'Secvență camion': 'Truck sequence',
  'Nr. comandă client': 'Customer order no.',
  'Status Marfă': 'Cargo Status',
  'Preț Transport': 'Transport Price',
  'Metri podea ocupați': 'Occupied loading metres',
  'Șofer & Vehicul': 'Driver & Vehicle',
  'Informații Contact': 'Contact Information',
  'Aceste date provin din snapshotul salvat pe transport și nu se modifică retroactiv.': 'This data comes from the snapshot saved on the transport and does not change retroactively.',
  'Vămi / Trecere frontieră': 'Customs / Border Crossing',
  'Trimis pentru semnare electronică': 'Sent for electronic signature',
  'Nu există CMR asociat încă': 'No CMR is associated yet',
  'Creează CMR Digital': 'Create Digital CMR',
  'Istoric status vehicul pentru Transport #': 'Vehicle status history for Transport #',
  'Camion:': 'Truck:',
  'Nu există raportări de status vehicul.': 'There are no vehicle status reports.',
  'Problemă #': 'Issue #',
  'Nu există probleme raportate pentru acest transport': 'There are no reported issues for this transport',
  'Șofer atribuit': 'Assigned driver',
  'Vezi CMR (Poză)': 'View CMR (Photo)',
  'Generează Document': 'Generate Document',
  'Generează Foaie de Parcurs': 'Generate Trip Sheet',
  'Vezi Documente Semnate': 'View Signed Documents',
  'Vezi Documente': 'View Documents',
  'Status de la Șofer': 'Driver Status',
  'Adresă expeditor / Sender address': 'Sender address',
  'Țară expeditor / Sender country': 'Sender country',
  'Adresă destinatar / Consignee address': 'Consignee address',
  'Țară destinatar / Consignee country': 'Consignee country',
  'Țara livrare / Country of delivery': 'Country of delivery',
  'Localitate încărcare / Place of loading': 'Place of loading',
  'Țara încărcare / Country of loading': 'Country of loading',
  'Documente anexate / Annexed documents': 'Annexed documents',
  'Rută / Route': 'Route',
  'Adresă transportator / Carrier address': 'Carrier address',
  'Țara transportator / Carrier country': 'Carrier country',
  'Auto (marcă) / Vehicle (make)': 'Vehicle (make)',
  'Număr circulație / Plate number': 'Plate number',
  'Rezerve și observații / Reservations': 'Reservations and notes',
  'Mărci și numere / Marks and numbers': 'Marks and numbers',
  'Natura mărfii / Nature of goods': 'Nature of goods',
  'Descriere mărfuri / Goods description': 'Goods description',
  'Instrucțiuni expeditor / Sender instructions': 'Sender instructions',
  'Instrucțiuni declarații / Declarations instructions': 'Declaration instructions',
  'Instrucțiuni vamale / Customs instructions': 'Customs instructions',
  'Convenții speciale / Special agreements': 'Special agreements',
  'Prescripții de francare / Freight payment': 'Freight payment instructions',
  'Metodă plată / Payment method': 'Payment method',
  'Semnătură expeditor / Sender signature': 'Sender signature',
  'Semnătură transportator / Carrier signature': 'Carrier signature',
  'Semnătură destinatar / Consignee signature': 'Consignee signature',
  'Informații lipsă pentru intervenție': 'Missing service-job information',
  'Fără transport asociat': 'No associated transport',
  'Nu există transporturi disponibile': 'No transports available',
  'Factură service': 'Service invoice',
  'Titlu factură': 'Invoice title',
  'Descriere factură': 'Invoice description',
  'Dubă': 'Van',
  'Se încarcă vehiculele...': 'Loading vehicles...',
  'Selectați camionul': 'Select the truck',
  'Selectați remorca': 'Select the trailer',
  'Selectați duba': 'Select the van',
  'Nu există dube disponibile': 'No vans available',
  'Detalii intervenție': 'Service-job details',
  'Locație service': 'Service location',
  'Date și kilometraj': 'Dates and mileage',
  'Km la ieșire': 'Exit mileage',
  'Ore funcționare': 'Operating hours',
  'Descriere defect și operațiuni': 'Fault description and operations',
  'Descrieți problema identificată...': 'Describe the identified issue...',
  'Operațiuni efectuate': 'Operations performed',
  'Descrieți lucrările efectuate...': 'Describe the work performed...',
  'Mecanici alocați': 'Assigned mechanics',
  'Cost manoperă (': 'Labour cost (',
  'Data notificare programată': 'Scheduled notification date',
  'Veți primi o notificare la această dată pentru a verifica starea intervenției': 'You will receive a notification on this date to check the service-job status',
  'Se încarcă': 'Loading',
  'Foaie nouă': 'New trip sheet',
  'Transporturile zilei sunt transformate automat în trasee editabile.': 'The day’s transports are automatically converted into editable routes.',
  'Nu există transporturi pentru data aleasă. Poți crea foaia manual sau poți alege altă zi.': 'There are no transports for the selected date. You can create the sheet manually or choose another day.',
  'Șoferul are': 'The driver has',
  'camioane în ziua selectată. Verifică numărul auto înainte de generare.': 'trucks on the selected day. Check the vehicle number before generating.',
  'Nu există camioane disponibile.': 'No trucks are available.',
  'Număr selectat:': 'Selected number:',
  'Mărfuri': 'Goods',
  'Poți corecta orice locație, oră, kilometraj sau observație.': 'You can correct any location, time, mileage, or note.',
  'Adaugă traseu': 'Add route',
  'PDF-ul acceptă maximum': 'The PDF supports a maximum of',
  'trasee. Șterge sau grupează liniile suplimentare.': 'routes. Delete or group the additional rows.',
  'Total calculat': 'Calculated total',
  'Generează și descarcă': 'Generate and download',
  'Istoric documente și generare din transporturile unei zile': 'Document history and generation from a day’s transports',
  'Creează foaie nouă': 'Create new trip sheet',
  'Documente generate': 'Generated documents',
  'Actualizează istoricul': 'Refresh history',
  'Documentele sunt păstrate în dosarul șoferului.': 'Documents are kept in the driver’s folder.',
  'Nu există încă foi de parcurs': 'There are no trip sheets yet',
  'Alege o zi, verifică traseele și generează primul document.': 'Choose a day, review the routes, and generate the first document.',
  'Creează prima foaie': 'Create the first sheet',
  'Reîncarcă transporturile zilei într-un formular editabil': 'Reload the day’s transports into an editable form',
  'Refă / editează': 'Recreate / edit',
  'Adresă expeditor': 'Sender address',
  'Țară expeditor': 'Sender country',
  'Adresă destinatar': 'Recipient address',
  'Țară destinatar': 'Recipient country',
  'LOCAȚII & DATE': 'LOCATIONS & DATES',
  'Loc de încărcare': 'Loading location',
  'Rută transport': 'Transport route',
  'DETALII MARFĂ': 'CARGO DETAILS',
  'Mărci/Numere': 'Marks/Numbers',
  'Număr colete': 'Number of packages',
  'Descriere mărfuri': 'Goods description',
  'INSTRUCȚIUNI & CONVENȚII': 'INSTRUCTIONS & AGREEMENTS',
  'Instrucțiuni expeditor': 'Sender instructions',
  'Instrucțiuni declarații': 'Declaration instructions',
  'Instrucțiuni vamale': 'Customs instructions',
  'Convenții speciale': 'Special agreements',
  'INFORMAȚII PLATĂ': 'PAYMENT INFORMATION',
  'Metodă plată': 'Payment method',
  'Preț transport': 'Transport price',
  'ÎNCHEIERE': 'COMPLETION',
  'INFORMAȚII SUPLIMENTARE': 'ADDITIONAL INFORMATION',
  'Rezerve și observații': 'Reservations and notes',
  'Prescripții francare': 'Freight payment instructions',
  'câmpuri': 'fields',
  'Codul expiră în': 'The code expires in',
  'Salvare automată': 'Automatic saving',
  'Vă mulțumim pentru colaborare!': 'Thank you for your cooperation!',
  'Ultima actualizare status:': 'Last status update:',
  'Semnare electronică': 'Electronic signing',
  'Semnătură electronică': 'Electronic signature',
  'Dacă nu vezi formularul, apasă pe „Deschide în tab nou”. Linkul este unic pentru codul primit.': 'If you do not see the form, select “Open in a new tab”. The link is unique to the code you received.',
  'Momentan nu am primit link-ul de semnare. Încearcă să reîmprospătezi sau deschide linkul de semnare când devine disponibil.': 'The signing link has not been received yet. Refresh or open it when it becomes available.',
  'Semnături electronice': 'Electronic signatures',
  'Cereri și documente semnate': 'Requests and signed documents',
  'Nu există cereri de semnătură electronică vizibile pentru acest transport.': 'There are no visible electronic-signature requests for this transport.',
  'Creată:': 'Created:',
  'Nu există documente semnate disponibile pentru acest transport.': 'There are no signed documents available for this transport.',
  'Deschide / descarcă': 'Open / download',
  'Acces temporar semnătură': 'Temporary signature access',
  'Documente CMR fizice': 'Physical CMR documents',
  'CMR editabil fără autentificare': 'Editable CMR without authentication',
  'Salvează acum': 'Save now',
  'Vizualizează PDF': 'View PDF',
  'Modificările sunt salvate automat după câteva secunde de pauză.': 'Changes are saved automatically after a few seconds of inactivity.',
  'Câmpuri:': 'Fields:',
  'Generează cod UIT pentru transport #': 'Generate UIT code for transport #',
  'Completați câmpurile de mai jos și trimiteți către ANAF. Formularul este precompletat din datele transportului/CMR, dar trebuie verificat înainte de trimitere.': 'Complete the fields below and submit them to ANAF. The form is prefilled from the transport/CMR data but must be checked before submission.',
  'Tip operațiune': 'Operation type',
  'Selectează tip operațiune': 'Select operation type',
  'Scop operațiune (implicit)': 'Operation purpose (default)',
  'Pentru tipul selectat, ANAF impune automat scopul "Același cu operațiunea" (BR-205).': 'For the selected type, ANAF automatically requires the purpose “Same as the operation” (BR-205).',
  '+ Adaugă bun': '+ Add item',
  'Denumire marfă': 'Goods name',
  'Unitate de măsură': 'Unit of measure',
  'Valoare lei fără TVA': 'Value in RON excluding VAT',
  'Scop operațiune': 'Operation purpose',
  'Număr vehicul': 'Vehicle number',
  'Număr remorcă': 'Trailer number',
  'Țara organizator': 'Organiser country',
  'Documente de transport': 'Transport documents',
  '+ Adaugă document': '+ Add document',
  'Tip document': 'Document type',
  'Data document': 'Document date',
  'Țara partener': 'Partner country',
  'ID încărcare existent:': 'Existing upload ID:',
  'Poți verifica direct statusul răspunsului ANAF pentru acest ID.': 'You can check the ANAF response status directly for this ID.',
  'Status ANAF:': 'ANAF status:',
  'Răspunsul ANAF nu conține erori de validare.': 'The ANAF response contains no validation errors.',
  'Data răspuns:': 'Response date:',
  'Referință verificare:': 'Verification reference:',
  'Modifică detaliile transportului': 'Update transport details',
  'modificări)': 'changes)',
  'Transport prin casă de expediție': 'Freight-forwarding transport',
  'Sunt disponibile numai câmpurile operaționale relevante. Resursele interne, prețul de flotă, profitabilitatea și CMR-ul nu se aplică.': 'Only relevant operational fields are available. Internal resources, fleet price, profitability, and CMR do not apply.',
  'Resursele nu mai pot fi asignate unui transport finalizat sau șters.': 'Resources can no longer be assigned to a completed or deleted transport.',
  'Se încarcă camioanele...': 'Loading trucks...',
  'Fără camion': 'No truck',
  'Se încarcă remorcile...': 'Loading trailers...',
  'Tip Marfă': 'Cargo Type',
  'Ex: Materiale de construcții': 'E.g. Construction materials',
  'Număr Comandă': 'Order Number',
  'Date folosite în raportul tur-retur. Km manual are prioritate peste km sincronizați din Arobs.': 'Data used in the round-trip report. Manual kilometres take priority over kilometres synchronized from AROBS.',
  'Sincronizarea este disponibilă după finalizarea transportului.': 'Synchronization is available after the transport is completed.',
  'Status AROBS': 'AROBS Status',
  'Sursă km': 'Kilometre source',
  'Sursă combustibil': 'Fuel source',
  'Vămi / Trecere frontieră ·': 'Customs / Border Crossing ·',
  'Ex: Nădlac': 'E.g. Nădlac',
  'Ex: control documente': 'E.g. document check',
  'Modificări': 'Changes',
  'Câmpuri modificate:': 'Changed fields:',
  'Salvează (': 'Save (',
  'Transportul nu a putut fi încărcat': 'The transport could not be loaded',
  'Se încarcă transportul…': 'Loading transport…',
  'Pregătim toate datele pentru editare.': 'Preparing all data for editing.',
  'Se încarcă setările...': 'Loading settings...',
  'Setări Autentificare în Doi Pași': 'Two-Factor Authentication Settings',
  'Protejează-ți contul cu un nivel suplimentar de securitate': 'Protect your account with an additional layer of security',
  'Codurile se trimit pe email. Asigură-te că adresa este corectă.': 'Codes are sent by email. Make sure the address is correct.',
  'Email lipsă': 'Missing email',
  'Status Curent': 'Current Status',
  'Contul tău este protejat cu autentificare în doi pași. Vei primi un cod pe email de fiecare dată când te autentifici.': 'Your account is protected by two-factor authentication. You will receive a code by email each time you sign in.',
  'Autentificarea în doi pași nu este activată. Activează-o pentru a-ți proteja mai bine contul.': 'Two-factor authentication is not enabled. Enable it to better protect your account.',
  'Dezactivează 2FA': 'Disable 2FA',
  'Activează 2FA': 'Enable 2FA',
  'Ce este autentificarea în doi pași?': 'What is two-factor authentication?',
  'Autentificarea în doi pași (2FA) adaugă un nivel suplimentar de securitate contului tău. Pe lângă parolă, vei avea nevoie de un cod temporar trimis pe email pentru a te autentifica.': 'Two-factor authentication (2FA) adds an extra layer of security to your account. In addition to your password, you will need a temporary code sent by email to sign in.',
  '🛡️ Protecție sporită împotriva accesului neautorizat': '🛡️ Increased protection against unauthorized access',
  '🔐 Securitate avansată pentru datele tale': '🔐 Advanced security for your data',
  '📱 Suport pentru dispozitive multiple (până la 10 sesiuni active)': '📱 Support for multiple devices (up to 10 active sessions)',
  'Cum funcționează:': 'How it works:',
  'Introduci numărul de telefon și parola ca de obicei': 'Enter your phone number and password as usual',
  'Primești un cod de 6 cifre pe email': 'Receive a 6-digit code by email',
  'Codul expiră după 5 minute pentru securitate maximă': 'The code expires after 5 minutes for maximum security',
  'Asigură-te că ai acces la adresa de email asociată contului tău înainte de a activa 2FA.': 'Make sure you can access the email address associated with your account before enabling 2FA.',
  'Confirmă Dezactivarea 2FA': 'Confirm Disabling 2FA',
  'Pentru a dezactiva autentificarea în doi pași, te rugăm să introduci parola contului tău.': 'To disable two-factor authentication, enter your account password.',
  'Parolă:': 'Password:',
  'Intervenție negăsită': 'Service job not found',
  'Tip Vehicul:': 'Vehicle Type:',
  'Număr Înmatriculare:': 'Registration Number:',
  'Detalii Intervenție': 'Service Job Details',
  'Tip Intervenție:': 'Service Job Type:',
  'Locație Service:': 'Service Location:',
  'Monedă:': 'Currency:',
  'Documente:': 'Documents:',
  'Operațiuni Efectuate:': 'Operations Performed:',
  'Date și Kilometraj': 'Dates and Mileage',
  'Data Intrare:': 'Entry Date:',
  'Data Ieșire:': 'Exit Date:',
  'Km la Ieșire:': 'Exit Mileage:',
  'Ore Funcționare:': 'Operating Hours:',
  'Mecanici Alocați': 'Assigned Mechanics',
  'Acțiuni Rapide': 'Quick Actions',
  'Marchează În Lucru': 'Mark In Progress',
  'Marchează Finalizat': 'Mark Completed',
  'Anulează Intervenția': 'Cancel Service Job',
  'Manoperă:': 'Labour:',
  'Factură': 'Invoice',
  'Listă Piese': 'Parts List',
  'Registru Intervenții Service': 'Service Job Register',
  'Gestionați toate intervențiile de service pentru flota dumneavoastră': 'Manage all service jobs for your fleet',
  'Intervenție nouă': 'New service job',
  'Programări': 'Appointments',
  'Căutați după număr referință, defect, operațiuni...': 'Search by reference number, fault, or operations...',
  'Toate Locațiile': 'All Locations',
  'De la data': 'From date',
  'Până la data': 'To date',
  'Data intrare (desc)': 'Entry date (desc)',
  'Data intrare (asc)': 'Entry date (asc)',
  'Șterge toate filtrele': 'Clear all filters',
  'Se încarcă intervențiile...': 'Loading service jobs...',
  'Adăugați prima intervenție': 'Add the first service job',
  'Nr. Referință': 'Reference No.',
  'Data Intrare': 'Entry Date',
  'Ieșire:': 'Exit:',
  '15 per pagină': '15 per page',
  '30 per pagină': '30 per page',
  '50 per pagină': '50 per page',
  'Tip transport': 'Transport type',
  'Camion extern:': 'External truck:',
  'Starea resurselor este informativă pentru': 'Resource status is informative for',
  '; disponibilitatea este verificată din nou la salvare.': '; availability is checked again when saving.',
  'Șoferul selectat nu este disponibil pentru perioada': 'The selected driver is not available for the period',
  '. Alege un alt șofer din lista filtrată.': '. Choose another driver from the filtered list.',
  'șoferi eligibili cunoscuți pentru perioada': 'known eligible drivers for the period',
  'CAMION': 'TRUCK',
  'TIP': 'TYPE',
  'Selectează transportatorul': 'Select carrier',
  'Data comenzii': 'Order date',
  'Referință client': 'Customer reference',
  'Referință transportator': 'Carrier reference',
  'Date externe opționale': 'Optional external details',
  'Telefon șofer': 'Driver phone',
  'Informații vizibile doar echipei interne': 'Information visible to the internal team only',
  'Se creează câte un CMR pentru fiecare casetă. Locurile de încărcare și descărcare se preiau din transport.': 'One CMR is created for each card. Loading and unloading locations are taken from the transport.',
  'LOC ÎNCĂRCARE': 'LOADING LOCATION',
  'Loc încărcare pentru acest CMR': 'Loading location for this CMR',
  'Partener casă de expediție': 'Freight-forwarding partner',
  'Ce tip de transport creezi?': 'What type of transport are you creating?',
  'Selectează tipul înainte de completarea datelor. Pentru transportul național, secțiunea de vămi nu va fi afișată.': 'Select the type before completing the data. The customs section is not displayed for domestic transport.',
  'Păstrează selecția curentă și închide': 'Keep the current selection and close',
  'Tip selectat:': 'Selected type:',
  'Vămi incomplete': 'Incomplete customs data',
  'Este obligatoriu să adaugi țările prin care transportul trece.': 'You must add the countries through which the transport passes.',
  'Șoferul menționat nu e găsit': 'The specified driver was not found',
  '”, dar acest nume nu există în lista de șoferi. Restul câmpurilor au fost completate unde s-au potrivit.': '”, but this name does not exist in the driver list. The remaining fields were completed where possible.',
  'Vehiculul menționat nu e găsit': 'The specified vehicle was not found',
  'AI a citit următoarele numere, dar nu le-a găsit în listele disponibile:': 'AI read the following numbers but did not find them in the available lists:',
  'cereri rămase': 'requests remaining',
  'Selectează Fișiere': 'Select Files',
  'sau trage și plasează fișierele aici': 'or drag and drop files here',
  'fișiere •': 'files •',
  'MB per fișier': 'MB per file',
  'Acceptăm: imagini (JPEG, PNG, WebP, GIF) și PDF-uri (max 10 pagini)': 'Accepted: images (JPEG, PNG, WebP, GIF) and PDFs (max 10 pages)',
  'Fișiere selectate (': 'Selected files (',
  'Instrucțiuni pentru analiză': 'Analysis instructions',
  'Ex: Extrage textul din document, identifică expeditorul și destinatarul...': 'E.g. Extract text from the document and identify the sender and recipient...',
  'opțiuni avansate': 'advanced options',
  'Format răspuns': 'Response format',
  'Înalt (OCR)': 'High (OCR)',
  'Scăzut (Rapid)': 'Low (Fast)',
  'Se analizează...': 'Analyzing...',
  'Analiza completă!': 'Analysis complete!',
  '• Fișiere:': '• Files:',
  'Rezultat Analiză': 'Analysis Result',
  'Copiază': 'Copy',
  'Analiză Nouă': 'New Analysis',
  'Folosește Rezultatul': 'Use Result',
  'Pasul 1: PDF CMR atașat automat': 'Step 1: CMR PDF attached automatically',
  'PDF-ul CMR curent a fost generat automat și atașat pentru semnare. Continuă pentru a adăuga semnatarii.': 'The current CMR PDF was generated automatically and attached for signing. Continue to add signers.',
  'Documente încărcate la transport': 'Documents uploaded to the transport',
  'Nu există documente PDF încărcate. Poți încărca unul nou mai jos.': 'There are no uploaded PDF documents. You can upload one below.',
  'sau fă click pentru a selecta (max 25 MiB)': 'or click to select (max 25 MiB)',
  'Pasul 2: Configurează Semnatarii': 'Step 2: Configure Signers',
  'câmp fix în CMR': 'fixed field in CMR',
  'Șofer din listă': 'Driver from list',
  'Caută șofer...': 'Search driver...',
  'Nu am găsit șoferi pentru căutarea ta.': 'No drivers matched your search.',
  'După selectare, numele/email/telefonul se completează automat și pot fi editate manual.': 'After selection, name, email, and phone are completed automatically and can be edited manually.',
  'Telefon în format internațional (ex: +40712345678)': 'Phone in international format (e.g. +40712345678)',
  'Expiră în 1 zi': 'Expires in 1 day',
  'Expiră în 3 zile': 'Expires in 3 days',
  'Expiră în 7 zile': 'Expires in 7 days',
  'Expiră în 14 zile': 'Expires in 14 days',
  'Cerere Trimisă cu Succes!': 'Request Sent Successfully!',
  'Copiază link-ul de semnare': 'Copy signing link',
  'Vei primi o notificare când toate semnăturile au fost completate.': 'You will receive a notification when all signatures are complete.',
  'Încarcă Document Nou': 'Upload New Document',
  'Data expirării *': 'Expiry date *',
  'Fișier *': 'File *',
  'Înapoi la Lista Camioane': 'Back to Truck List',
  'Informații Generale': 'General Information',
  'Nr. Înmatriculare:': 'Registration No.:',
  'An fabricație:': 'Year of manufacture:',
  'Specificații Tehnice': 'Technical Specifications',
  'Tip combustibil:': 'Fuel type:',
  'Capacitate încărcare:': 'Load capacity:',
  'Informații Service': 'Service Information',
  'Următoarea revizie:': 'Next service:',
  'ITP expiră:': 'ITP expires:',
  'RCA expiră:': 'RCA expires:',
  'Șofer Asignat': 'Assigned Driver',
  'Documente Camion': 'Truck Documents',
  'Încarcă primul document': 'Upload the first document',
  'Istoric Intervenții': 'Service History',
  'Adaugă Intervenție': 'Add Service Job',
  'Tip:': 'Type:',
  'Total documente:': 'Total documents:',
  'Nu am putut încărca toate detaliile CMR': 'Not all CMR details could be loaded',
  'Se încarcă detaliile complete ale CMR-ului...': 'Loading complete CMR details...',
  'total': 'total',
  'Nr. Circulație': 'Plate No.',
  'Nu există CMR digital pentru acest transport': 'There is no digital CMR for this transport',
  'Completează CMR Digital': 'Complete Digital CMR',
  'Fișier indisponibil': 'File unavailable',
  'Nu există CMR-uri fizice scanate pentru acest transport': 'There are no scanned physical CMR documents for this transport',
  'Semnături Electronice (': 'Electronic Signatures (',
  'Nu există cereri de semnătură electronică pentru acest transport': 'There are no electronic-signature requests for this transport',
  'Poți crea o cerere de semnătură din pagina principală de transport': 'You can create a signature request from the main transport page',
  'Documente semnate (': 'Signed documents (',
  'După finalizarea semnării, documentele vor apărea aici pentru descărcare.': 'After signing is complete, the documents will appear here for download.',
  'Închide previzualizarea': 'Close preview',
  'Imaginea anterioară': 'Previous image',
  'Imaginea nu poate fi încărcată.': 'The image cannot be loaded.',
  'Imaginea următoare': 'Next image',
  'Planificare expediții, monitorizare blocaje EU 561 și timer live 45h.': 'Shipment planning, EU 561 constraint monitoring, and live 45h timer.',
  'Calendar săptămânal': 'Weekly calendar',
  'Șoferi blocați (': 'Blocked drivers (',
  'Săptămână selectată (Luni-Duminică)': 'Selected week (Monday–Sunday)',
  'Click pe o zi pentru detalii expediție + transporturi': 'Click a day for shipment and transport details',
  'Săptămâna anterioară': 'Previous week',
  'Săptămâna următoare': 'Next week',
  'Șoferi blocați în această săptămână:': 'Drivers blocked this week:',
  'Se încarcă datele săptămânii...': 'Loading week data...',
  'Săptămâna este goală momentan, dar calendarul rămâne vizibil pentru planificare.': 'The week is currently empty, but the calendar remains visible for planning.',
  'Plecări': 'Departures',
  'Expediție ·': 'Shipment ·',
  'Expediție · Sosire': 'Shipment · Arrival',
  'Șoferi blocați': 'Blocked drivers',
  'Listă actualizată live.': 'Live-updated list.',
  'Se încarcă șoferii blocați...': 'Loading blocked drivers...',
  'Nu există șoferi blocați în acest moment.': 'There are no blocked drivers at this time.',
  'Se încarcă detaliile UIT...': 'Loading UIT details...',
  'Nu am putut încărca detaliile.': 'The details could not be loaded.',
  'Status ANAF': 'ANAF Status',
  'Vehicule din flotă și coduri UIT active din ANAF': 'Fleet vehicles and active UIT codes from ANAF',
  'Reîncarcă date': 'Reload data',
  'Aplică': 'Apply',
  'Datele UIT nu au putut fi încărcate.': 'UIT data could not be loaded.',
  'Înregistrări UIT active': 'Active UIT records',
  'Verifică rapid după număr de înmatriculare': 'Quickly check by registration number',
  'Caută UIT': 'Search UIT',
  'Nu există coduri UIT active pentru acest număr.': 'There are no active UIT codes for this number.',
  'Vehicule și coduri UIT': 'Vehicles and UIT codes',
  'Caută vehicul...': 'Search vehicle...',
  'Se încarcă datele UIT...': 'Loading UIT data...',
  'Nu există vehicule de afișat.': 'There are no vehicles to display.',
  'Aplică filtrul CIF și reîncarcă datele.': 'Apply the CIF filter and reload the data.',
  'Fără UIT activ': 'No active UIT',
  'Nu există document în această poziție.': 'There is no document in this position.',
  'zile rămase': 'days remaining',
  'Caută categoria...': 'Search category...',
  'Nicio categorie găsită.': 'No category found.',
  'Folder documente': 'Document folder',
  'documente în acest folder.': 'documents in this folder.',
  'Modifică numele și categoria documentului.': 'Update the document name and category.',
  'Nu există documente în acest folder.': 'There are no documents in this folder.',
  'Completează informațiile și selectează fișierul documentului.': 'Complete the information and select the document file.',
  '(opțional)': '(optional)',
  'Fișier document': 'Document file',
  'PDF sau imagine, în limitele de încărcare acceptate': 'PDF or image, within the accepted upload limits',
  'Foldere documente': 'Document folders',
  'Alege un folder pentru a vedea documentele prezente, viitoare și istoricul expirat.': 'Choose a folder to view current and future documents and the expiry history.',
  'Nu există documente încărcate pentru acest vehicul.': 'There are no documents uploaded for this vehicle.',
  'Folosește parametrii vehiculului': 'Use vehicle parameters',
  'Calculează ruta optimă pentru camion și remorcă': 'Calculate the optimal route for the truck and trailer',
  'Lățime (cm)': 'Width (cm)',
  'Înălțime (cm)': 'Height (cm)',
  'Greutate Totală Permisă (kg)': 'Total Permitted Weight (kg)',
  'Greutate Goală (kg)': 'Empty Weight (kg)',
  'Număr de Axe': 'Number of Axles',
  'Tip Motor': 'Engine Type',
  'Tip Combustibil': 'Fuel Type',
  'Restricții': 'Restrictions',
  'Cod Restricție Tunel': 'Tunnel Restriction Code',
  'B - Restricție medie': 'B - Medium restriction',
  'C - Restricție mare': 'C - High restriction',
  'D - Restricție foarte mare': 'D - Very high restriction',
  'E - Restricție maximă': 'E - Maximum restriction',
  '💾 Salvează modificările înapoi în baza de date vehicul': '💾 Save changes back to the vehicle database',
  'Total bonuri': 'Total receipts',
  'Adaugă bon': 'Add receipt',
  'Se detectează automat suma, moneda și descrierea': 'Amount, currency, and description are detected automatically',
  'Se detectează datele din bon...': 'Detecting receipt data...',
  'Te rugăm așteaptă până se completează câmpurile găsite.': 'Please wait while the detected fields are completed.',
  'Fișier bon': 'Receipt file',
  'Sumă manuală': 'Manual amount',
  'Monedă manuală': 'Manual currency',
  'Se detectează din bon sau completezi manual': 'Detected from the receipt or entered manually',
  'Nu există bonuri pentru acest transport': 'There are no receipts for this transport',
  'Încărcat de user #': 'Uploaded by user #',
  'Corectează bon': 'Correct receipt',
  'Inclus în profitabilitate': 'Included in profitability',
  'Sumă': 'Amount',
  'Se încarcă sesiunile...': 'Loading sessions...',
  'Nu există sesiuni active.': 'There are no active sessions.',
  'Sesiunea curentă': 'Current session',
  'Timp rămas:': 'Time remaining:',
  'Revocă sesiunea': 'Revoke session',
  '🔄 Reîncarcă sesiuni': '🔄 Reload sessions',
  '⚠️ Deconectează toate dispozitivele': '⚠️ Sign out all devices',
  'Informații despre sesiuni:': 'Session information:',
  'Fiecare dispozitiv pe care te autentifici creează o sesiune nouă': 'Each device you sign in on creates a new session',
  'Poți avea maximum': 'You can have a maximum of',
  'Sesiunile expiră automat după 7 zile': 'Sessions expire automatically after 7 days',
  'Nu poți revoca sesiunea curentă (folosește Logout)': 'You cannot revoke the current session (use Sign out)',
  'Revocarea unei sesiuni deconectează imediat acel dispozitiv': 'Revoking a session immediately signs out that device',
  'Detalii șofer': 'Driver details',
  'Săptămâna': 'Week',
  'Se încarcă detaliile șoferului...': 'Loading driver details...',
  'Driving săptămânal': 'Weekly driving',
  'Driving 2 săptămâni': 'Two-week driving',
  'Șofer blocat:': 'Blocked driver:',
  'Valorile sunt afișate în ore, convertite din secunde.': 'Values are displayed in hours, converted from seconds.',
  'Expediții active/programate': 'Active/scheduled shipments',
  'Limită de rată activă. Acțiunile sunt blocate încă': 'Rate limit active. Actions remain blocked',
  'Nu există expediții active sau programate pentru acest șofer.': 'There are no active or scheduled shipments for this driver.',
  '· Sosire estimată': '· Estimated arrival',
  'Modifică orele': 'Change hours',
  'Finalizare manuală': 'Manual completion',
  'Intervenții Programate': 'Scheduled Service Jobs',
  'Vizualizați și gestionați intervențiile programate pentru următoarele 7 zile': 'View and manage service jobs scheduled for the next 7 days',
  'Registru intervenții': 'Service register',
  'Statistici intervenții': 'Service statistics',
  'Total programate': 'Total scheduled',
  'Mâine': 'Tomorrow',
  'Întârziate': 'Overdue',
  'Programează Intervenție': 'Schedule Service Job',
  'Nu există intervenții programate pentru următoarele 7 zile': 'There are no service jobs scheduled for the next 7 days',
  'Programează Prima Intervenție': 'Schedule the First Service Job',
  'Data programată': 'Scheduled date',
  'Începe': 'Start',
  'Status Detaliat Transport': 'Detailed Transport Status',
  'Încarcă fotografii vehicul': 'Upload vehicle photos',
  'Atașează poze relevante pentru camion, remorcă sau situația observată.': 'Attach relevant photos of the truck, trailer, or observed situation.',
  'fișier(e) selectate': 'file(s) selected',
  'Istoric status vehicul': 'Vehicle status history',
  'Nu există raportări de status vehicul pentru acest transport.': 'There are no vehicle status reports for this transport.',
  'Raportează problemă pe oprire': 'Report issue at a stop',
  'Opțional. Alege locația doar dacă problema ține de o oprire din traseu.': 'Optional. Choose a location only if the issue concerns a route stop.',
  'Problemă generală pe transport': 'General transport issue',
  'Descriere problemă': 'Issue description',
  'Ex: Rampa este blocată, marfa nu este pregătită, adresa nu este corectă...': 'E.g. The loading bay is blocked, cargo is not ready, or the address is incorrect...',
  'Fotografie opțională': 'Optional photo',
  'Se incarca...': 'Loading...',
  'Nu există fotografii de nereguli pentru acest transport': 'There are no issue photos for this transport',
  'Vezi avizul încărcat': 'View uploaded delivery note',
  'Părți': 'Parties',
  'Număr *': 'Number *',
  'Cumpărător': 'Buyer',
  '+ Adaugă Produs': '+ Add Product',
  'Unitate Măsură': 'Unit of Measure',
  'Număr Mijloc Transport': 'Transport Vehicle Number',
  'Se încarcă numărul de înmatriculare...': 'Loading registration number...',
  'Oră Estimativă Livrare': 'Estimated Delivery Time',
  'Document Atașat': 'Attached Document',
  'Fișier selectat:': 'Selected file:',
  'Continuă la următoarea secțiune': 'Continue to the next section',
  'Generează și descarcă rapoarte PDF pentru concediile șoferilor': 'Generate and download PDF reports for driver leave',
  'Selectează anul': 'Select year',
  'Selectează luna': 'Select month',
  'Statistici generale pentru luna selectată': 'General statistics for the selected month',
  'Lista șoferilor în concediu în acea lună': 'List of drivers on leave that month',
  'Distribuția zilnică a concediilor': 'Daily leave distribution',
  'Analiză pe șoferi și tendințe': 'Driver analysis and trends',
  'Lunile cu cele mai multe/puține concedii': 'Months with the most/fewest leave days',
  'Rata de aprobare și metrici de performanță': 'Approval rate and performance metrics',
  'Descarcă Raport PDF': 'Download PDF Report',
  'Raportul va fi descărcat automat în format PDF după generare.': 'The report will be downloaded automatically as a PDF after generation.',
  'Fișierul va conține date confidențiale - păstrați-l în siguranță.': 'The file will contain confidential data—keep it secure.',
  'Adaugă linie': 'Add row',
  'Generează foaie de parcurs': 'Generate trip sheet',
  'Număr auto': 'Vehicle number',
  'Preț combustibil': 'Fuel price',
  'Km in țară (opțional)': 'Domestic km (optional)',
  'Km exterior (opțional)': 'International km (optional)',
  'Nume persoană care calculează': 'Name of person performing the calculation',
  'Nume șofer semnătură': 'Driver name for signature',
  'Total KM:': 'Total KM:',
  'Calculație:': 'Calculation:',
  'Generează și descarcă PDF': 'Generate and download PDF',
  'Se descarcă numele implicit:': 'Default download name:',
  'Adaugă observație nouă': 'Add new note',
  'Conform API, observația se poate crea doar pe un transport existent, iar șoferul este preluat automat din transport.': 'According to the API, a note can only be created for an existing transport, and the driver is taken automatically from the transport.',
  'Șofer *': 'Driver *',
  'Nu există transporturi active disponibile': 'No active transports available',
  'Ex: întârziere, documente, comportament': 'E.g. delay, documents, behaviour',
  'Completează observația pentru transport...': 'Enter the transport note...',
  'Nu există șoferi cu transport activ în acest moment. Observația se poate crea doar cu transport activ.': 'There are currently no drivers with an active transport. A note can only be created for an active transport.',
  'Observații după șofer': 'Notes by driver',
  'Selectează un șofer din listă pentru a vedea observațiile lui.': 'Select a driver from the list to view their notes.',
  'Nu există observații disponibile.': 'No notes are available.',
  'Nu există observații pentru șoferul selectat.': 'There are no notes for the selected driver.',
  'Caută după nume sau număr de înmatriculare...': 'Search by name or registration number...',
  'Nu există rezultate pentru căutarea curentă.': 'There are no results for the current search.',
  'Salarii și diurne șoferi ·': 'Driver salaries and per diem ·',
  'Configurează valorile care se alocă automat curselor din luna selectată.': 'Configure values automatically allocated to trips in the selected month.',
  'Configurare șoferi': 'Driver configuration',
  'Salariul este lunar în EUR. Diurna poate fi configurată în EUR sau RON.': 'Salary is monthly in EUR. Per diem can be configured in EUR or RON.',
  'Caută șoferul...': 'Search driver...',
  'Diurnă / zi': 'Per diem / day',
  'Număr zile': 'Number of days',
  'Total diurnă în EUR': 'Total per diem in EUR',
  'Nu există șoferi pentru căutarea curentă.': 'There are no drivers for the current search.',
  'Planificare Rută Transport': 'Transport Route Planning',
  'Calculați și optimizați ruta pentru acest transport': 'Calculate and optimize the route for this transport',
  'Puncte Adăugate': 'Added Points',
  'Calculare Rută': 'Route Calculation',
  'Adaugă puncte pe hartă și calculează cea mai eficientă rută; poți ajusta traseul manual tragând linia.': 'Add points on the map and calculate the most efficient route; you can adjust it manually by dragging the line.',
  'Se calculează ruta...': 'Calculating route...',
  'Calculează Rută Optimă': 'Calculate Optimal Route',
  'Cost distanță:': 'Distance cost:',
  '✓ Datele rutei au fost salvate automat în transport': '✓ Route data was saved automatically to the transport',
  'Șterge toate punctele (': 'Delete all points (',
  'Adaugă un motiv (opțional). Va fi vizibil pentru șofer.': 'Add a reason (optional). It will be visible to the driver.',
  'Ex: Perioadă deja rezervată / lipsă documente': 'E.g. Period already booked / missing documents',
  'Se încarcă calendarul...': 'Loading calendar...',
  'Luna anterioară': 'Previous month',
  'Luna următoare': 'Next month',
  'Concediu în Așteptare': 'Leave Pending',
  'Se încarcă cererile...': 'Loading requests...',
  'Acest șofer nu are cereri de concediu pentru filtrul selectat.': 'This driver has no leave requests for the selected filter.',
  'Niciun document atașat': 'No document attached',
  'cereri în total)': 'requests in total)',
});

export const legacyEnglishPatterns = [
  [/^(\d+) (camion|camioane) (găsit|găsite|în flotă)$/, (_, count, noun, suffix) => `${count} ${Number(count) === 1 ? 'truck' : 'trucks'} ${suffix === 'în flotă' ? 'in the fleet' : 'found'}`],
  [/^(\d+) (remorcă|remorci) (găsită|găsite|în flotă)$/, (_, count, noun, suffix) => `${count} ${Number(count) === 1 ? 'trailer' : 'trailers'} ${suffix === 'în flotă' ? 'in the fleet' : 'found'}`],
  [/^(\d+) (șofer|șoferi) (găsit|găsiți|înregistrați)$/, (_, count, noun, suffix) => `${count} ${Number(count) === 1 ? 'driver' : 'drivers'} ${suffix === 'înregistrați' ? 'registered' : 'found'}`],
  [/^Pagina (\d+) din (\d+)$/, 'Page $1 of $2'],
  [/^(\d+) zile rămase$/, '$1 days remaining'],
  [/^Expiră în (\d+) zile$/, 'Expires in $1 days'],
  [/^Transport #(\S+) șters cu succes$/, 'Transport #$1 deleted successfully'],
  [/^Șofer #(\S+)$/, 'Driver #$1'],
  [/^Remorcă #(\S+)$/, 'Trailer #$1'],
  [/^(\d+) documente încărcate$/, '$1 documents uploaded'],
  [/^(\d+) documente$/, '$1 documents'],
  [/^(\d+) activități înregistrate$/, '$1 activities recorded'],
];

export const translateLegacyText = (language, value) => {
  if (language !== 'en' || typeof value !== 'string' || !value.trim()) return value;
  const leading = value.match(/^\s*/)?.[0] || '';
  const trailing = value.match(/\s*$/)?.[0] || '';
  const source = value.trim().replace(/\s+/g, ' ');
  const exact = legacyEnglishCatalog[source];
  if (exact) return `${leading}${exact}${trailing}`;

  for (const [pattern, replacement] of legacyEnglishPatterns) {
    if (pattern.test(source)) return `${leading}${source.replace(pattern, replacement)}${trailing}`;
  }
  return value;
};
